import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from './Translation';

type Language = 'EN' | 'FR' | 'ES';

interface TranslationContextType {
  currentLanguage: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string, params?: Record<string, any>) => string;
}

const TranslationContext = createContext<TranslationContextType | undefined>(undefined);

export const TranslationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState<Language>('FR');

  useEffect(() => {
    const savedLang = localStorage.getItem('language') as Language;
    if (savedLang && ['EN', 'FR', 'ES'].includes(savedLang)) {
      setCurrentLanguage(savedLang);
    }
  }, []);

  const setLanguage = (lang: Language) => {
    setCurrentLanguage(lang);
    localStorage.setItem('language', lang);
    document.documentElement.lang = lang.toLowerCase();
  };

  const t = (key: string, params?: Record<string, any>): string => {
    let translated = translations[currentLanguage][key] || key;
    if (params) {
      // Remplacer les espaces réservés comme {variable} par leurs valeurs
      Object.entries(params).forEach(([paramKey, value]) => {
        const placeholder = `{${paramKey}}`;
        translated = translated.replace(placeholder, String(value));
      });
    }
    return translated;
  };

  return (
    <TranslationContext.Provider value={{ currentLanguage, setLanguage, t }}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslation = () => {
  const context = useContext(TranslationContext);
  if (!context) {
    throw new Error('useTranslation must be used within a TranslationProvider');
  }
  return context;
};

export default TranslationContext;

// // TranslationContext.tsx
// import React, { createContext, useContext, useState, useEffect } from 'react';
// import { translations } from './Translation';

// type Language = 'EN' | 'FR' | 'ES';

// interface TranslationContextType {
//   currentLanguage: Language;
//   setLanguage: (lang: Language) => void;
//   t: (key: string) => string;
// }

// const TranslationContext = createContext<TranslationContextType | undefined>(undefined);

// export const TranslationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
//   const [currentLanguage, setCurrentLanguage] = useState<Language>('FR');

//   useEffect(() => {
//     const savedLang = localStorage.getItem('language') as Language;
//     if (savedLang && ['EN', 'FR', 'ES'].includes(savedLang)) {
//       setCurrentLanguage(savedLang);
//     }
//   }, []);

//   const setLanguage = (lang: Language) => {
//     setCurrentLanguage(lang);
//     localStorage.setItem('language', lang);
//     document.documentElement.lang = lang.toLowerCase();
//   };

//   const t = (key: string): string => {
//     return translations[currentLanguage][key] || key;
//   };

//   return (
//     <TranslationContext.Provider value={{ currentLanguage, setLanguage, t }}>
//       {children}
//     </TranslationContext.Provider>
//   );
// };

// export const useTranslation = () => {
//   const context = useContext(TranslationContext);
//   if (!context) {
//     throw new Error('useTranslation must be used within a TranslationProvider');
//   }
//   return context;
// };
// export default TranslationContext ;



